import { memo } from "react";
import TruckIcon from "@/assets/icons/truck";
import CardIcon from "@/assets/icons/card";
import RefreshIcon from "@/assets/icons/refresh";
import TimerIcon from "@/assets/icons/timer";

const features = [
  {
    icon: TruckIcon,
    title: "Free Delivery",
    subtitle: "On orders above $250",
  },
  {
    icon: CardIcon,
    title: "Secure Payment",
    subtitle: "100% protected",
  },
  {
    icon: RefreshIcon,
    title: "Easy Returns",
    subtitle: "7 days return policy",
  },
  {
    icon: TimerIcon,
    title: "Fast Shipping",
    subtitle: "2-4 business days",
  },
] as const;

export const ProductFeatureCards = memo(() => (
  <div className="grid grid-cols-2 gap-3 mt-4 w-full">
    {features.map(({ icon: Icon, title, subtitle }) => (
      <div
        key={title}
        className="bg-white border border-gray-200 rounded-xl shadow-sm p-4 flex items-center gap-3"
      >
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary [&_svg]:w-5 [&_svg]:h-5 [&_path]:fill-current [&_polyline]:stroke-current [&_line]:stroke-current">
          <Icon />
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-gray-900 text-sm">{title}</p>
          <p className="text-gray-500 text-xs">{subtitle}</p>
        </div>
      </div>
    ))}
  </div>
));

ProductFeatureCards.displayName = "ProductFeatureCards";
